(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["j-vacuum-care-2026"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('j-vacuum-carousel-2026')) {
  customElements.define('j-vacuum-carousel-2026', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.j-vacuum-carousel-2026__track');
      this.slides = [...this.querySelectorAll('.j-vacuum-carousel-2026__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = false;
      this.scrollMode = this.dataset.mode === 'scroll';
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.scrollMode) {
        this.initScrollMode(signal);
        return;
      }
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-slide]');
        const arrow = event.target.closest('[data-direction]');
        const pause = event.target.closest('[data-pause]');
        if (dot) this.go(Number(dot.dataset.slide));
        if (arrow) this.go(this.index + Number(arrow.dataset.direction));
        if (pause) {
          this.paused = !this.paused;
          pause.setAttribute('aria-pressed', String(this.paused));
          pause.setAttribute('aria-label', this.paused ? '繼續自動輪播' : '暫停自動輪播');
          pause.textContent = this.paused ? '播放' : '暫停';
        }
      }, { signal });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(next);
      }, { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
          this.dots.forEach((dot, index) => {
            if (index === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        });
      }, { passive: true, signal });
      this.resizeObserver = new ResizeObserver(() => this.go(this.index, true));
      this.resizeObserver.observe(this.track);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index >= 0) {
          this.editorSelected = true;
          this.go(index, true);
        }
      }, { signal });
      document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; }, { signal });
      if (this.dataset.autoplay === 'true' && this.slides.length > 1) {
        this.timer = setInterval(() => {
          if (this.paused || this.editorSelected || this.reducedMotion.matches || document.hidden || this.matches(':hover, :focus-within')) return;
          const bounds = this.getBoundingClientRect();
          if (bounds.bottom <= 0 || bounds.top >= innerHeight) return;
          this.go(this.index + 1);
        }, Number(this.dataset.interval) || 5000);
      }
    }
    initScrollMode(signal) {
      this.index = -1;
      this.activate(0);
      this.queueScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateScroll();
        });
      };
      this.measureScroll = () => {
        const height = Math.max(0, ...this.slides.map(slide => slide.getBoundingClientRect().height));
        const viewport = document.documentElement.clientHeight;
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--vacuum-sticky-offset')) || 0;
        const staticMode = this.slides.length < 2 || this.reducedMotion.matches;
        const wasPinned = this.pinned;
        this.requestedIndex = null;
        this.classList.toggle('is-scroll-static', staticMode);
        this.classList.toggle('is-scroll-pinned', !staticMode);
        this.pinned = !staticMode;
        const stageHeight = Math.min(height, Math.max(1, viewport - offset));
        this.readOverflow = Math.max(0, height - stageHeight);
        this.classList.toggle('is-scroll-tall', this.readOverflow > 0);
        this.pinTop = Math.max(offset, (viewport - stageHeight + offset) / 2);
        // Each tall slide gets enough scroll distance to read from its top to its bottom.
        this.segment = this.readOverflow + Math.max(1, viewport * (Number(this.dataset.scrollDistance) || 100) / 100);
        this.travel = this.segment * this.slides.length;
        this.style.setProperty('--vacuum-pin-top', `${this.pinTop}px`);
        this.style.setProperty('--vacuum-stage-height', `${stageHeight}px`);
        this.style.height = this.pinned ? `${stageHeight + this.travel}px` : '';
        if (staticMode) {
          this.slides.forEach(slide => { slide.removeAttribute('aria-hidden'); slide.inert = false; });
        } else {
          if (!wasPinned) this.index = -1;
          this.updateScroll();
        }
      };
      window.addEventListener('scroll', this.queueScroll, { passive: true, signal });
      window.addEventListener('resize', this.measureScroll, { passive: true, signal });
      this.reducedMotion.addEventListener('change', this.measureScroll, { signal });
      this.track.addEventListener('load', this.measureScroll, { capture: true, signal });
      this.track.addEventListener('keydown', event => {
        if (!this.pinned || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1);
        this.go(index);
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.contains(event.target));
        if (index >= 0) this.go(index, true);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => {
        this.measureScroll();
      });
      this.resizeObserver.observe(this.track);
      this.slides.forEach(slide => this.resizeObserver.observe(slide));
      // Start decoding before the section reaches the viewport, including hidden slides.
      this.preloadObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.slides.forEach(slide => this.prepareSlide(slide));
        this.preloadObserver.disconnect();
      }, { rootMargin: '1200px 0px' });
      this.preloadObserver.observe(this);
      this.measureScroll();
      document.fonts?.ready.then(() => { if (this.isConnected) this.measureScroll(); });
    }
    prepareSlide(slide) {
      if (!slide.vacuumReady) {
        slide.vacuumReady = Promise.all([...slide.querySelectorAll('img')].map(image => {
          image.loading = 'eager';
          return image.decode ? image.decode().catch(() => {}) : Promise.resolve();
        }));
      }
      return slide.vacuumReady;
    }
    activate(index) {
      if (index === this.index) return;
      const focused = this.slides.some(slide => slide.contains(document.activeElement));
      const previous = this.index;
      clearTimeout(this.transitionTimer);
      this.index = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-leaving', this.pinned && i === previous && !active);
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.transitionTimer = setTimeout(() => {
        this.slides.forEach(slide => slide.classList.remove('is-leaving'));
      }, 450);
      if (focused) this.track.focus({ preventScroll: true });
    }
    updateScroll() {
      if (!this.pinned) return;
      const progress = Math.max(0, Math.min(1, (this.pinTop - this.getBoundingClientRect().top) / this.travel));
      const next = Math.min(this.slides.length - 1, Math.floor(progress * this.slides.length));
      const withinSlide = progress * this.travel - next * this.segment;
      this.slides[next].style.setProperty('--vacuum-read-offset', `${-Math.min(this.readOverflow, withinSlide)}px`);
      if (next === this.requestedIndex) return;
      this.requestedIndex = next;
      this.prepareSlide(this.slides[next]).then(() => {
        if (this.isConnected && this.pinned && this.requestedIndex === next) this.activate(next);
      });
    }
    go(index, instant = false) {
      const count = this.slides.length;
      if (!count) return;
      if (this.scrollMode) {
        const next = Math.max(0, Math.min(count - 1, index));
        if (!this.pinned) {
          this.slides[next].scrollIntoView({ behavior: 'instant', block: 'nearest' });
          return;
        }
        const top = scrollY + this.getBoundingClientRect().top - this.pinTop + this.travel * (next + 0.1) / count;
        window.scrollTo({ top, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth' });
        return;
      }
      this.index = (index + count) % count;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.preloadObserver?.disconnect();
      this.requestedIndex = null;
      clearTimeout(this.transitionTimer);
      clearInterval(this.timer);
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
